import { notEmpty } from '@shared/utils/array';
import type {
  FormatDateOptions,
  FormatTimeOptions,
  TimeZone,
} from '@shared/utils/date';
import { formatDateTz, formatTimeTz, userTimeZone } from '@shared/utils/date';
import type { ReactNode } from 'react';

export interface DateTimeProps {
  value: Date | string | null | undefined;
  date?: boolean;
  time?: boolean;
  dateStyle?: FormatDateOptions['dateStyle'];
  timeStyle?: FormatTimeOptions['timeStyle'];
  timeZone?: TimeZone;
  empty?: ReactNode;
}

export function DateTime({
  value,
  date = true,
  time = true,
  dateStyle,
  timeStyle,
  timeZone,
  empty = null,
}: DateTimeProps) {
  if (value == null) {
    return empty;
  }
  if (!date && !time) {
    return null;
  }

  const tz = timeZone ?? userTimeZone();
  const formattedDate = date ? formatDateTz(value, tz, { dateStyle }) : null;
  const formattedTime = time ? formatTimeTz(value, tz, { timeStyle }) : null;

  return (
    <>{[formattedDate, formattedTime].filter(notEmpty).join(' ').trim()}</>
  );
}
